import React from 'react';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import type { SelectForColumnCellProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select/types';
import GenericReadonlyCell from '../generic-readonly-cell';

export default function FieldPrioritySelectContent({ value }: SelectForColumnCellProps) {
	const item = Array.isArray(value) ? value[0] : value;
	const text = isDefined(item) && isDefined(item.label) ? item.label : '';
	return <GenericReadonlyCell text={text} />;
}
